(function (window, document) {
  'use strict';

  // ============================================================
  // Constants
  // ============================================================
  var REFUSE_REASONS = [
    'prix_trop_bas',
    'conditions_non_acceptables',
    'delai_trop_long',
    'vendu_ailleurs',
    'change_avis',
    'autre',
  ];
  var EARTH_RADIUS_KM = 6371;
  var DAY_KEYS = ['lundi', 'mardi', 'mercredi', 'jeudi', 'vendredi', 'samedi', 'dimanche'];
  var DAY_LABELS = {
    lundi: 'Lun',
    mardi: 'Mar',
    mercredi: 'Mer',
    jeudi: 'Jeu',
    vendredi: 'Ven',
    samedi: 'Sam',
    dimanche: 'Dim',
  };

  // ============================================================
  // i18n & HTML escaping
  // ============================================================
  function t(key) {
    var i18n = window.buybackPortalI18n || {};
    return i18n[key] || key;
  }

  function escapeHtml(s) {
    if (s == null) return '';
    return String(s).replace(/[&<>"']/g, function (c) {
      return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c];
    });
  }
  var h = escapeHtml; // shortcut, used in template literals

  // ============================================================
  // Single dialog manager — "one modal at a time"
  // ============================================================
  var currentDialog = null;

  function isDialogBusy(dlg) {
    return !!(dlg && dlg.getAttribute('aria-busy') === 'true');
  }

  function getCurrentDialog() {
    return currentDialog;
  }

  function closeCurrentDialog() {
    if (currentDialog) {
      if (isDialogBusy(currentDialog)) return;
      try {
        currentDialog.close();
      } catch (e) {}
      try {
        currentDialog.remove();
      } catch (e) {}
      currentDialog = null;
    }
  }

  function createDialog(opts) {
    closeCurrentDialog();
    var dlg = document.createElement('dialog');
    dlg.className = 'bp-modal ' + (opts.className || '');
    if (opts.ariaLabel) dlg.setAttribute('aria-label', opts.ariaLabel);
    dlg.innerHTML = opts.content;
    document.body.appendChild(dlg);
    currentDialog = dlg;

    // Backdrop click → close (target is the dialog itself, not its inner container)
    dlg.addEventListener('click', function (e) {
      if (e.target !== dlg) return;
      if (isDialogBusy(dlg)) return;
      var dialogContent = dlg.querySelector('.bp-modal__container');
      if (!dialogContent) {
        closeCurrentDialog();
        return;
      }
      var r = dialogContent.getBoundingClientRect();
      if (e.clientX < r.left || e.clientX > r.right || e.clientY < r.top || e.clientY > r.bottom) {
        closeCurrentDialog();
      }
    });

    // ESC fermeture (native dialog fires "cancel")
    dlg.addEventListener('cancel', function (e) {
      e.preventDefault();
      if (isDialogBusy(dlg)) return;
      closeCurrentDialog();
    });

    // Polyfill simple : si HTMLDialogElement absent ou .showModal manquant
    if (typeof HTMLDialogElement === 'undefined' || !dlg.showModal) {
      dlg.setAttribute('open', '');
      dlg.style.cssText =
        'position:fixed;inset:0;z-index:9999;background:rgba(20,20,20,0.45);display:flex;align-items:center;justify-content:center;padding:16px;';
    } else {
      try {
        dlg.showModal();
      } catch (e) {
        dlg.setAttribute('open', '');
      }
    }

    if (typeof opts.onMount === 'function') opts.onMount(dlg);
    return dlg;
  }

  function bindClose(dlg, selector) {
    var btn = dlg.querySelector(selector);
    if (btn) btn.addEventListener('click', closeCurrentDialog);
  }

  // ============================================================
  // 1. Modal Calc Price (6 paragraphes flat depuis i18n)
  // ============================================================
  function openCalcPriceModal() {
    var paragraphsHtml = '';
    for (var i = 1; i <= 6; i++) {
      var key = 'modal_calc_price_paragraph_' + i;
      var p = t(key);
      if (p && p !== key) {
        paragraphsHtml += '<p class="bp-modal-calc__paragraph">' + h(p) + '</p>';
      }
    }
    var content =
      '<div class="bp-modal__container bp-modal-calc">' +
      '<button type="button" class="bp-modal__close" data-bp-modal-close aria-label="' +
      h(t('modal_close_aria')) +
      '">&times;</button>' +
      '<h2 class="bp-modal__title">' +
      h(t('modal_calc_price_title')) +
      '</h2>' +
      '<div class="bp-modal-calc__body">' +
      paragraphsHtml +
      '</div>' +
      '</div>';

    return createDialog({
      className: 'bp-modal--calc',
      content: content,
      ariaLabel: t('modal_calc_price_title'),
      onMount: function (dlg) {
        bindClose(dlg, '[data-bp-modal-close]');
      },
    });
  }

  // ============================================================
  // 2. Modal Store Select
  // ============================================================
  function normalizeStore(raw) {
    if (!raw || typeof raw !== 'object') return null;
    var hours = null;
    if (raw.horaires) {
      try {
        var once = typeof raw.horaires === 'string' ? JSON.parse(raw.horaires) : raw.horaires;
        hours = typeof once === 'string' ? JSON.parse(once) : once;
      } catch (e) {
        hours = null;
      }
    }
    var lat = raw.lat === '' || raw.lat == null ? null : Number(raw.lat);
    var lng = raw.long === '' || raw.long == null ? null : Number(raw.long);
    return {
      id: String(raw.id || ''),
      name: raw.name || '',
      address: raw.address || '',
      zip: (raw.zip || '').toString().trim(),
      city: raw.city || '',
      country: raw.country || null,
      lat: isNaN(lat) ? null : lat,
      long: isNaN(lng) ? null : lng,
      hours: hours,
    };
  }

  function haversineKm(lat1, lon1, lat2, lon2) {
    var toRad = function (d) {
      return (d * Math.PI) / 180;
    };
    var dLat = toRad(lat2 - lat1);
    var dLon = toRad(lon2 - lon1);
    var a =
      Math.sin(dLat / 2) * Math.sin(dLat / 2) +
      Math.cos(toRad(lat1)) * Math.cos(toRad(lat2)) * Math.sin(dLon / 2) * Math.sin(dLon / 2);
    return EARTH_RADIUS_KM * 2 * Math.atan2(Math.sqrt(a), Math.sqrt(1 - a));
  }

  function formatHoursRow(dayKey, dayData) {
    var label = DAY_LABELS[dayKey] || dayKey;
    if (!dayData || dayData.closed) {
      return `<span>${h(label)}</span><span>${h(t('modal_store_closed'))}</span>`;
    }
    var slots = (dayData.slots || [])
      .map(function (s) {
        return (s.open || '') + '-' + (s.close || '');
      })
      .join(' / ');
    return `<span>${h(label)}</span><span>${h(slots || '—')}</span>`;
  }

  var MAX_STORE_RESULTS = 10;
  var GEOCODE_DEBOUNCE_MS = 450;
  var GEOLOC_TIMEOUT_MS = 8000;

  function openDepotMethodSelectModal(opts) {
    opts = opts || {};
    var selected = opts.selectedMethod || null; // 'shop' | 'mint_direct'

    var renderCard = function (method, labelKey, descKey) {
      var isPre = selected === method;
      var selClass = isPre ? ' bp-modal-store__method-item--selected' : '';
      var selAttr = isPre ? ' checked' : '';
      return `<label class="bp-modal-store__method-item${selClass}" data-bp-method-item data-method="${h(method)}"><input type="radio" name="bp-depot-method" value="${h(method)}"${selAttr}><div class="bp-modal-store__method-body"><p class="bp-modal-store__name">${h(t(labelKey))}</p><p class="bp-modal-store__address">${h(t(descKey))}</p></div></label>`;
    };

    var continueDisabled = selected ? '' : ' disabled';
    var content = `<div class="bp-modal__container bp-modal-store"><button type="button" class="bp-modal__close" data-bp-modal-close aria-label="${h(t('modal_close_aria'))}">&times;</button><h2 class="bp-modal__title">${h(t('modal_store_method_title'))}</h2><p class="bp-modal__intro">${h(t('modal_store_method_intro'))}</p><div class="bp-modal-store__methods">${renderCard('shop', 'modal_store_method_shop_label', 'modal_store_method_shop_description')}${renderCard('mint_direct', 'modal_store_method_mint_direct_label', 'modal_store_method_mint_direct_description')}</div><p class="bp-modal-store__error" data-bp-store-error hidden></p><div class="bp-modal__actions"><button type="button" class="bp-cta-pastel" data-bp-method-continue${continueDisabled}>${h(t('modal_store_continue_cta'))}</button></div></div>`;

    return createDialog({
      className: 'bp-modal--store',
      content: content,
      ariaLabel: t('modal_store_method_title'),
      onMount: function (dlg) {
        bindClose(dlg, '[data-bp-modal-close]');
        var continueBtn = dlg.querySelector('[data-bp-method-continue]');
        var errEl = dlg.querySelector('[data-bp-store-error]');
        var continueLabel = continueBtn.textContent;

        var ctx = {
          setBusy: function (busy) {
            if (busy) {
              dlg.setAttribute('aria-busy', 'true');
              continueBtn.disabled = true;
              continueBtn.setAttribute('aria-busy', 'true');
              continueBtn.textContent = t('modal_store_loading_cta');
            } else {
              dlg.removeAttribute('aria-busy');
              continueBtn.removeAttribute('aria-busy');
              continueBtn.textContent = continueLabel;
              continueBtn.disabled = !selected;
            }
          },
          showError: function (msg) {
            if (!errEl) return;
            errEl.textContent = msg || t('modal_store_save_error');
            errEl.hidden = false;
          },
          clearError: function () {
            if (!errEl) return;
            errEl.textContent = '';
            errEl.hidden = true;
          },
          close: closeCurrentDialog,
        };

        dlg.querySelectorAll('[data-bp-method-item]').forEach(function (item) {
          item.addEventListener('click', function () {
            if (isDialogBusy(dlg)) return;
            ctx.clearError();
            selected = item.getAttribute('data-method');
            dlg.querySelectorAll('[data-bp-method-item]').forEach(function (i) {
              i.classList.remove('bp-modal-store__method-item--selected');
              var r = i.querySelector('input[type="radio"]');
              if (r) r.checked = false;
            });
            item.classList.add('bp-modal-store__method-item--selected');
            var rs = item.querySelector('input[type="radio"]');
            if (rs) rs.checked = true;
            continueBtn.disabled = false;
          });
        });
        continueBtn.addEventListener('click', function () {
          if (!selected || continueBtn.disabled) return;
          ctx.clearError();
          if (typeof opts.onSelectMethod === 'function') opts.onSelectMethod(selected, ctx);
        });
      },
    });
  }

  function openStoreSelectModal(rawStores, opts) {
    opts = opts || {};
    var stores = (Array.isArray(rawStores) ? rawStores : []).map(normalizeStore).filter(Boolean);
    var selectedId = opts.selectedId || null;
    var userCoords = null;
    var searchCoords = null;
    var geoStatus = 'pending'; // 'pending' | 'granted' | 'denied'
    var geocodeAbort = null;
    var geocodeTimer = null;

    var sortByDistance = function (coords) {
      return stores
        .slice()
        .map(function (s) {
          var d =
            s.lat != null && s.long != null
              ? haversineKm(coords.lat, coords.lng, s.lat, s.long)
              : Number.POSITIVE_INFINITY;
          return { store: s, dist: d };
        })
        .sort(function (a, b) {
          return a.dist - b.dist;
        })
        .slice(0, MAX_STORE_RESULTS)
        .map(function (e) {
          return e.store;
        });
    };

    var textFilter = function (q) {
      q = (q || '').toLowerCase().trim();
      if (!q) return [];
      return stores
        .filter(function (s) {
          var hay = (s.name + ' ' + s.city + ' ' + s.zip + ' ' + s.address).toLowerCase();
          return hay.indexOf(q) !== -1;
        })
        .slice(0, MAX_STORE_RESULTS);
    };

    var renderStoreItem = function (s) {
      var hoursHtml = '';
      if (s.hours)
        DAY_KEYS.forEach(function (d) {
          hoursHtml += formatHoursRow(d, s.hours[d]);
        });
      var isSelected = s.id === selectedId;
      var selClass = isSelected ? ' bp-modal-store__item--selected' : '';
      var selAttr = isSelected ? ' checked' : '';
      var hoursBlock = hoursHtml
        ? `<div class="bp-modal-store__hours-label">${h(t('modal_store_hours_label'))}</div><div class="bp-modal-store__hours">${hoursHtml}</div>`
        : '';
      return `<label class="bp-modal-store__item${selClass}" data-bp-store-item data-store-id="${h(s.id)}"><input type="radio" name="bp-store" value="${h(s.id)}"${selAttr}><div class="bp-modal-store__body"><p class="bp-modal-store__name">${h(s.name)}</p><p class="bp-modal-store__address">${h(s.address)}, ${h(s.zip)} ${h(s.city)}</p>${hoursBlock}</div></label>`;
    };

    var renderHint = function (msg) {
      return `<p class="bp-modal-store__hint">${h(msg)}</p>`;
    };

    var renderItems = function (searchText) {
      var query = (searchText || '').trim();
      var filtered;
      if (query) {
        if (searchCoords) {
          filtered = sortByDistance(searchCoords);
        } else {
          filtered = textFilter(query);
          if (filtered.length === 0) return renderHint(t('modal_store_search_no_match'));
        }
      } else if (userCoords) {
        filtered = sortByDistance(userCoords);
      } else if (geoStatus === 'pending') {
        return renderHint(t('modal_store_locating'));
      } else {
        return renderHint(t('modal_store_geoloc_denied_hint'));
      }
      if (filtered.length === 0) {
        return `<p class="bp-modal-store__empty">${h(t('modal_store_empty_state'))} <a href="mailto:achat@mint-bikes.com">achat@mint-bikes.com</a></p>`;
      }
      return filtered.map(renderStoreItem).join('');
    };

    var backBtnHtml =
      typeof opts.onBack === 'function'
        ? `<button type="button" class="bp-modal-store__back" data-bp-store-back>${h(t('modal_store_method_back'))}</button>`
        : '';
    var content = `<div class="bp-modal__container bp-modal-store"><button type="button" class="bp-modal__close" data-bp-modal-close aria-label="${h(t('modal_close_aria'))}">&times;</button><h2 class="bp-modal__title">${h(t('modal_store_title'))}</h2>${backBtnHtml}<div class="bp-modal-store__controls"><input type="search" class="bp-modal-store__search" data-bp-store-search placeholder="${h(t('modal_store_search_placeholder'))}"></div><div class="bp-modal-store__list" data-bp-store-list></div><p class="bp-modal-store__error" data-bp-store-error hidden></p><div class="bp-modal__actions"><button type="button" class="bp-cta-pastel bp-modal-store__no-nearby" data-bp-no-store-nearby>${h(t('modal_store_method_no_store_nearby_cta'))}</button><button type="button" class="bp-cta-pastel" data-bp-store-continue disabled>${h(t('modal_store_continue_cta'))}</button></div></div>`;

    return createDialog({
      className: 'bp-modal--store',
      content: content,
      ariaLabel: t('modal_store_title'),
      onMount: function (dlg) {
        var list = dlg.querySelector('[data-bp-store-list]');
        var search = dlg.querySelector('[data-bp-store-search]');
        var continueBtn = dlg.querySelector('[data-bp-store-continue]');
        var noNearbyBtn = dlg.querySelector('[data-bp-no-store-nearby]');

        var attachItemHandlers = function () {
          list.querySelectorAll('[data-bp-store-item]').forEach(function (item) {
            item.addEventListener('click', function () {
              selectedId = item.getAttribute('data-store-id');
              list.querySelectorAll('[data-bp-store-item]').forEach(function (i) {
                i.classList.remove('bp-modal-store__item--selected');
                var radio = i.querySelector('input[type="radio"]');
                if (radio) radio.checked = false;
              });
              item.classList.add('bp-modal-store__item--selected');
              var radioSel = item.querySelector('input[type="radio"]');
              if (radioSel) radioSel.checked = true;
              continueBtn.disabled = false;
            });
          });
        };

        var refresh = function () {
          list.innerHTML = renderItems(search.value);
          attachItemHandlers();
          continueBtn.disabled =
            !selectedId ||
            !stores.some(function (s) {
              return s.id === selectedId;
            });
        };

        var geocodeCity = function (query) {
          if (geocodeAbort) {
            try {
              geocodeAbort.abort();
            } catch (e) {}
          }
          geocodeAbort = typeof AbortController !== 'undefined' ? new AbortController() : null;
          var url =
            'https://nominatim.openstreetmap.org/search?format=json&limit=1&addressdetails=0&q=' +
            encodeURIComponent(query);
          var fetchOpts = { headers: { Accept: 'application/json' } };
          if (geocodeAbort) fetchOpts.signal = geocodeAbort.signal;
          fetch(url, fetchOpts)
            .then(function (r) {
              return r.ok ? r.json() : [];
            })
            .then(function (data) {
              if (search.value.trim() !== query) return; // user kept typing, ignore
              if (Array.isArray(data) && data.length && data[0].lat && data[0].lon) {
                searchCoords = { lat: Number(data[0].lat), lng: Number(data[0].lon) };
              } else {
                searchCoords = null;
              }
              refresh();
            })
            .catch(function () {
              // Aborted or network error: keep current state, fallback to text filter
            });
        };

        // Initial render (pending state)
        refresh();

        // Auto-request geolocation on open
        if (navigator.geolocation) {
          navigator.geolocation.getCurrentPosition(
            function (pos) {
              userCoords = { lat: pos.coords.latitude, lng: pos.coords.longitude };
              geoStatus = 'granted';
              refresh();
            },
            function () {
              geoStatus = 'denied';
              refresh();
            },
            { timeout: GEOLOC_TIMEOUT_MS, maximumAge: 5 * 60 * 1000 },
          );
        } else {
          geoStatus = 'denied';
          refresh();
        }

        search.addEventListener('input', function () {
          clearTimeout(geocodeTimer);
          var q = search.value.trim();
          if (q.length < 2) {
            searchCoords = null;
            refresh();
            return;
          }
          // Render text-filter immediately for feedback, then refine via geocoding
          refresh();
          geocodeTimer = setTimeout(function () {
            geocodeCity(q);
          }, GEOCODE_DEBOUNCE_MS);
        });

        bindClose(dlg, '[data-bp-modal-close]');

        var errEl = dlg.querySelector('[data-bp-store-error]');
        var continueLabel = continueBtn.textContent;
        var ctx = {
          setBusy: function (busy) {
            if (busy) {
              dlg.setAttribute('aria-busy', 'true');
              continueBtn.disabled = true;
              continueBtn.setAttribute('aria-busy', 'true');
              continueBtn.textContent = t('modal_store_loading_cta');
              if (noNearbyBtn) noNearbyBtn.disabled = true;
            } else {
              dlg.removeAttribute('aria-busy');
              continueBtn.removeAttribute('aria-busy');
              continueBtn.textContent = continueLabel;
              continueBtn.disabled = !selectedId;
              if (noNearbyBtn) noNearbyBtn.disabled = false;
            }
          },
          showError: function (msg) {
            if (!errEl) return;
            errEl.textContent = msg || t('modal_store_save_error');
            errEl.hidden = false;
          },
          clearError: function () {
            if (!errEl) return;
            errEl.textContent = '';
            errEl.hidden = true;
          },
          close: closeCurrentDialog,
        };

        if (typeof opts.onBack === 'function') {
          var backBtn = dlg.querySelector('[data-bp-store-back]');
          if (backBtn) {
            backBtn.addEventListener('click', function () {
              if (isDialogBusy(dlg)) return;
              closeCurrentDialog();
              opts.onBack();
            });
          }
        }

        continueBtn.addEventListener('click', function () {
          if (continueBtn.disabled || !selectedId) return;
          ctx.clearError();
          var chosen = null;
          for (var i = 0; i < stores.length; i++) {
            if (stores[i].id === selectedId) {
              chosen = stores[i];
              break;
            }
          }
          if (chosen && typeof opts.onSelect === 'function') opts.onSelect(chosen, ctx);
        });

        if (noNearbyBtn) {
          noNearbyBtn.addEventListener('click', function () {
            if (isDialogBusy(dlg) || noNearbyBtn.disabled) return;
            noNearbyBtn.disabled = true; // sync, AVANT l'appel async
            ctx.clearError();
            if (typeof opts.onNoStoreNearby === 'function') opts.onNoStoreNearby(ctx);
          });
        }
      },
    });
  }

  function renderNoStoreNearbySuccess(dlg, onClose) {
    if (!dlg) return;
    var container = dlg.querySelector('.bp-modal__container');
    if (!container) return;
    var fired = false;
    function fire() {
      if (fired) return;
      fired = true;
      if (typeof onClose === 'function') {
        try {
          onClose();
        } catch (e) {}
      }
    }
    var checkSvg =
      '<svg class="bp-modal-docs__success-check" viewBox="0 0 24 24" aria-hidden="true" width="56" height="56"><path d="M5 13l4 4L19 7" fill="none" stroke="currentColor" stroke-width="3" stroke-linecap="round" stroke-linejoin="round"/></svg>';
    container.innerHTML =
      '<button type="button" class="bp-modal__close" data-bp-modal-close aria-label="' +
      h(t('modal_close_aria')) +
      '">&times;</button>' +
      '<div class="bp-modal-docs__success" role="status" aria-live="polite">' +
      checkSvg +
      '<h2 class="bp-modal-docs__success-title">' +
      h(t('modal_store_method_no_store_nearby_success_title')) +
      '</h2>' +
      '<p class="bp-modal-docs__success-subtitle">' +
      h(t('modal_store_method_no_store_nearby_success_subtitle')) +
      '</p>' +
      '<button type="button" class="bp-cta-pastel" data-bp-no-store-success-close>' +
      h(t('modal_store_method_no_store_nearby_success_close')) +
      '</button>' +
      '</div>';

    // Fire onClose pour TOUS les modes de fermeture (bouton, X, Escape, backdrop)
    bindClose(dlg, '[data-bp-no-store-success-close]');
    bindClose(dlg, '[data-bp-modal-close]');
    var successCloseBtn = dlg.querySelector('[data-bp-no-store-success-close]');
    if (successCloseBtn) successCloseBtn.addEventListener('click', fire, { once: true });
    var closeBtn = dlg.querySelector('[data-bp-modal-close]');
    if (closeBtn) closeBtn.addEventListener('click', fire, { once: true });
    // <dialog> natif : cancel = Escape, close = .close()
    dlg.addEventListener('cancel', fire);
    dlg.addEventListener('close', fire);
  }

  // ============================================================
  // 5. Modal Refuse
  // ============================================================
  function openRefuseModal(opts) {
    opts = opts || {};
    var reasonOpts = REFUSE_REASONS.map(function (r) {
      return `<option value="${h(r)}">${h(t('modal_refuse_reasons_' + r))}</option>`;
    }).join('');

    var content = `<div class="bp-modal__container bp-modal-refuse"><button type="button" class="bp-modal__close" data-bp-modal-close aria-label="${h(t('modal_close_aria'))}">&times;</button><h2 class="bp-modal__title">${h(t('modal_refuse_title'))}</h2><label class="bp-modal__field"><span class="bp-modal__label">${h(t('modal_refuse_reason_label'))}</span><select data-bp-refuse-reason>${reasonOpts}</select></label><label class="bp-modal__field"><span class="bp-modal__label">${h(t('modal_refuse_comment_label'))}</span><textarea data-bp-refuse-comment rows="3"></textarea></label><p class="bp-modal-store__error" data-bp-refuse-error hidden></p><div class="bp-modal__actions"><button type="button" class="bp-link-button" data-bp-refuse-cancel>${h(t('modal_refuse_cancel'))}</button><button type="button" class="bp-cta-pastel" data-bp-refuse-submit>${h(t('modal_refuse_submit'))}</button></div></div>`;

    return createDialog({
      className: 'bp-modal--refuse',
      content: content,
      ariaLabel: t('modal_refuse_title'),
      onMount: function (dlg) {
        bindClose(dlg, '[data-bp-modal-close]');
        bindClose(dlg, '[data-bp-refuse-cancel]');
        var submitBtn = dlg.querySelector('[data-bp-refuse-submit]');
        var cancelBtn = dlg.querySelector('[data-bp-refuse-cancel]');
        var closeBtn = dlg.querySelector('[data-bp-modal-close]');
        var errEl = dlg.querySelector('[data-bp-refuse-error]');
        var reasonEl = dlg.querySelector('[data-bp-refuse-reason]');
        var commentEl = dlg.querySelector('[data-bp-refuse-comment]');
        var submitLabel = submitBtn.textContent;

        var ctx = {
          setBusy: function (busy) {
            if (busy) {
              dlg.setAttribute('aria-busy', 'true');
              submitBtn.disabled = true;
              submitBtn.setAttribute('aria-busy', 'true');
              submitBtn.textContent = t('modal_refuse_loading_cta');
              if (cancelBtn) cancelBtn.disabled = true;
              if (closeBtn) closeBtn.disabled = true;
              if (reasonEl) reasonEl.disabled = true;
              if (commentEl) commentEl.disabled = true;
            } else {
              dlg.removeAttribute('aria-busy');
              submitBtn.disabled = false;
              submitBtn.removeAttribute('aria-busy');
              submitBtn.textContent = submitLabel;
              if (cancelBtn) cancelBtn.disabled = false;
              if (closeBtn) closeBtn.disabled = false;
              if (reasonEl) reasonEl.disabled = false;
              if (commentEl) commentEl.disabled = false;
            }
          },
          showError: function (msg) {
            if (!errEl) return;
            errEl.textContent = msg || t('modal_refuse_save_error');
            errEl.hidden = false;
          },
          clearError: function () {
            if (!errEl) return;
            errEl.textContent = '';
            errEl.hidden = true;
          },
          close: closeCurrentDialog,
        };

        submitBtn.addEventListener('click', function () {
          if (submitBtn.disabled || isDialogBusy(dlg)) return;
          ctx.clearError();
          var reason = reasonEl ? reasonEl.value : '';
          var comment = commentEl ? commentEl.value : '';
          if (typeof opts.onConfirm === 'function') opts.onConfirm({ reason: reason, comment: comment }, ctx);
        });
      },
    });
  }

  // ============================================================
  // Export
  // ============================================================
  window.buybackPortalModals = {
    openCalcPrice: openCalcPriceModal,
    openDepotMethodSelect: openDepotMethodSelectModal,
    openStoreSelect: openStoreSelectModal,
    openDocsUpload: function (opts) {
      return window.buybackPortalModalDocs && window.buybackPortalModalDocs.open(opts);
    },
    openRefuse: openRefuseModal,
    renderNoStoreNearbySuccess: renderNoStoreNearbySuccess,
    getCurrentDialog: getCurrentDialog,
    closeCurrent: closeCurrentDialog,
    _createDialog: createDialog,
    _closeCurrent: closeCurrentDialog,
    _bindClose: bindClose,
    _renderNoStoreNearbySuccess: renderNoStoreNearbySuccess,
    _getCurrentDialog: getCurrentDialog,
    // exposé pour tests
    _normalizeStore: normalizeStore,
    _haversineKm: haversineKm,
  };
})(window, document);
